import { TableCell } from "@mui/material";

type Props = {
  columns: any[];
  month: number;
  year: number;
};

const CalendarGridPOB: React.FC<Props> = ({ columns, year, month }) => {
  const daysInMonth = new Date(year, month, 0).getDate();
  const daysArray = Array.from(
    { length: daysInMonth },
    (_, index) => index + 1
  );

  return (
    <>
      <TableCell
        style={{
          border: "1px solid white",
          padding: 0,
          backgroundColor: "#f9fafd",
          width: 20,
        }}
      />
      {columns.map((column) => (
        <TableCell
          padding="none"
          style={{
            border: "1px solid white",
            width:
              column.field === "Status"
                ? 20
                : column.field === "Territory"
                ? 60
                : 80,
            textAlign: "center",
            padding: 0,
            wordWrap: "break-word",
            overflowWrap: "break-word",
            backgroundColor: "#f9fafd",
            fontSize: 12,
          }}
          key={column.field}
        >
          {column.field === "Status" ? "" : column.field}
        </TableCell>
      ))}
      <TableCell
        align="center"
        style={{
          border: "1px solid white",
          padding: 0,
          width: 40,
          backgroundColor: "#f9fafd",
          fontSize: 12,
        }}
      >
        Total
      </TableCell>
      {daysArray.map((day) => (
        <TableCell
          style={{
            border: "1px solid white",
            padding: 0,
            backgroundColor: "#f9fafd",
            textAlign: "center",
            fontSize: 12,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {day}
        </TableCell>
      ))}
    </>
  );
};

export default CalendarGridPOB;
